import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { supabase } from '../supabaseClient';

const OAuthCallbackPage = () => {
  const navigate = useNavigate();
  const { setSessionFromToken } = useAuth();

  useEffect(() => {
    const complete = async () => {
      try {
        const { data, error } = await supabase.auth.getSession();
        if (error || !data.session) {
          navigate('/login', { replace: true });
          return;
        }
        await setSessionFromToken(data.session.access_token);
        navigate('/', { replace: true });
      } catch (err) {
        console.error('OAuth completion failed', err);
        navigate('/login', { replace: true });
      }
    };

    void complete();
  }, [navigate, setSessionFromToken]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-[#050815] via-[#0a0f1f] to-[#050815] text-slate-100">
      <div className="rounded-2xl border border-white/10 bg-[#0c1428]/90 px-6 py-4 shadow-soft">
        <p className="text-sm text-slate-200">Completing sign-in with Google…</p>
      </div>
    </div>
  );
};

export default OAuthCallbackPage;
